import React, { useState, useEffect, Fragment } from "react";
import PageHeader from "../../components/common/PageHeader";
import UserFilterList from "./UserFilterList";
import Listing from "./Listing";
import NoRecord from "../../components/common/NoRecord";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import LoaderUI from "../../components/common/loader";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { set } from "react-ga";
import { get, add, update, changeStatus, resendEmail } from "../../context/actions/operator";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
const MySwal = withReactContent(Swal);

const UserList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState("10");
  const [resPayload, setResPayload] = useState();
  const [sort, setSort] = useState("createdAt");
  const [order, setOrder] = useState(-1);
  const [theKeyword, setKeyword] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  let [payload, setPayload] = useState({ page, limit });
  const [searchInProgress, setSearchInProgress] = useState(false);
  const [status, setStatus] = useState(null);
  const [plan, setPlan] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [nameSort, setNameSort] = useState(false);

  const history = useHistory();

  useEffect(() => {
    users();
  }, [limit]);

  const users = () => {
    setShowLoader(true);
    setSearchInProgress(true);
    payload.role =  "operator"
    dispatch(
      get(payload, (res) => {
        res.totalCurrentDoc = res?.docs?.length
        setResPayload(res);
        setShowLoader(false);
        setSearchInProgress(false);
      })
    );
  };
  const _clear = () => {
    setShowLoader(true);
    setKeyword(false);
    setPayload({ limit: limit });
    setSearchInProgress(true);

    dispatch(
      get({ page: 1, limit: limit, role : "operator" }, (res) => {
        res.totalCurrentDoc = res?.docs?.length
        setResPayload(res);
        setNameSort(false);
        setShowLoader(false);
        setSort("createdAt");
        setOrder(-1)
        setStatus(null);
        setSearchInProgress(false);
      })
    );
  };

  const filters = (params) => {
    setSearchInProgress(true);
    let param = { ...params, limit, sort, order };
    setKeyword(params?.keyword);
    setStatus(params?.status);
    if (!param?.keyword)
      // if we are clear search keyword there should be selcted page
      param = { ...param, page: 1 };
    setPayload(param);
    setShowLoader(true);
    setButtonDisabled(true);
    if (params?.keyword) {
      setNameSort(true);
    }
    param.role =  "operator"
    dispatch(
      get(param, (res) => {
        res.totalCurrentDoc = res?.docs?.length
        setResPayload(res);
        setShowLoader(false);
        setSearchInProgress(false);
        setButtonDisabled(false);
        // setPage(1)
      })
    );
  };

  const _handlePageChange = (page) => {
    console.log("hello")
    payload = { ...payload, page };

    setPage(page);
    setShowLoader(true);
    payload.role =  "operator"
    dispatch(
      get(payload, (res) => {
        res.totalCurrentDoc = res?.docs?.length
        setResPayload(res);
        setShowLoader(false);
      })
    );
  };

  const update = (id, params) => {
    params.deleted = !params.deleted;
    dispatch(
      update(id, params, (res) => {
        users();
      })
    );
  };

  const _sort = (params) => {
    setNameSort(false);
    setOrder(params?.order);
    setSort(params?.key);

    let param = { ...params, limit, sort, order, status, plan, page: 1 };

    if (params?.key) {
      param.sort = params?.key;
    }

    if (theKeyword) {
      param.keyword = theKeyword;
    } // if we are clear search keyword there should be selcted page
    param = { ...param };

    setPayload(param);

    setShowLoader(true);

    param.role =  "operator"

    dispatch(
      get(param, (res) => {
        res.totalCurrentDoc = res?.docs?.length
        setResPayload(res);
        setShowLoader(false);
      })
    );
    setPage(1);
  };

  /**
   * @description method call to soft delete an organization
   * @param {String} id accepting string
   * @param {Object} params accepting object
   */
  const handleUserStatusChange = (id, params) => {
    let str = "You want to Deactivate this User";
    let substr = "Yes, Deactivate it!";
    if (params.deleted === true) {
      str = "You want to Activate this User";
      substr = "Yes, Activate it!";
    }

    MySwal.fire({
      title: "Are you sure?",
      text: str,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: substr,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          changeStatus({deleted : !params.deleted}, id, (result) => {
            if (result) {
              setPayload(payload);
              payload.role =  "operator"
              dispatch(
                get(payload, (res) => {
                  res.totalCurrentDoc = res?.docs?.length
                  setResPayload(res);
                  setShowLoader(false);
                })
              );
            }
          })
        );
        toast.success("User Status Updated");
      }
    });
  };

  return (
    <>
      <div className="page-wrapper">
        <PageHeader className="with-btn">
          <div className="left-col d-inline-flex align-items-center">
            {/* <Button color="link" className="backBtn">
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </Button> */}
           Users
          </div>
          <div className="right-col ms-auto">
            <Button
              color="secondary"
              className="add-btn"
              onClick={() => {
                history.push("/add-user");
              }}
            >
              Add Users
            </Button>
          </div>
        </PageHeader>
        <div className="inner-wrapper position-relative">
          <div className="row-section">
            <div className="filter-list-blc">
              <UserFilterList
                filters={filters}
                plans={resPayload?.plans}
                clearFilters={_clear}
                searchInProgress={searchInProgress}
                status={status}
                buttonDisabled={buttonDisabled}
                _setStatus={(val) => setStatus(val)}
                page={page}
                _setPage={setPage}
                disabledButton={showLoader}
              />
            </div>
          </div>
<br />
          {showLoader ? (
            <LoaderUI message FullWindow={false} />
          ) : (
            <Fragment>
              <div className="row-section">
                {resPayload?.docs?.length !== 0 ? (
                  <Listing
                    _update={update}
                    users={resPayload}
                    _sort={_sort}
                    _order={order}
                    sortKey={sort}
                    page={page}
                    _setPage={setPage}
                    limit={limit}
                    _handleLimit={(val) => {
                      setLimit(val);
                      setPage(1);
                      setPayload({ ...payload, limit: val });
                    }}
                    _handlePageChange={_handlePageChange}
                    _handleUserStatusChange={handleUserStatusChange}
                    _nameSort={nameSort}
                  />
                ) : (
                  <NoRecord />
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {/* <AddOrganizationModal /> */}
    </>
  );
};

export default UserList;
